// extracted by mini-css-extract-plugin
export default {"table":"BOQ_table__X4iN1","leadId":"BOQ_leadId__AQJTh","created":"BOQ_created__XkXMm","approved":"BOQ_approved__fUDX7"};